import { useSelector } from 'react-redux';
import { BusinessModelDisplayName } from '../../constants/operators';
import SlideCard from '../common/SlideCard';

export function SellerBusinessModel() {
  const { businessModel } = useSelector((state) => state.operators);

  return <SlideCard title="Business Model">{BusinessModelDisplayName[businessModel]}</SlideCard>;
}
